import { Stack, Typography } from '@mui/material'

const TONE_COLOR = {
  success: 'var(--app-success, #107c10)',
  error: 'var(--app-error, #a4262c)',
  muted: 'var(--app-text-tertiary)',
}

/**
 * What happened to a proposed write, once it is settled.
 *
 * The failure reason is shown rather than swallowed: "Couldn't send" alone
 * leaves the user unable to tell a missing Gmail connection from a rejected
 * recipient, and the only other copy of that reason is a server log.
 */
export default function ProposalOutcome({ label, tone, error }) {
  return (
    <Stack sx={{ mt: 1, gap: 0.25 }}>
      <Typography
        sx={{ fontSize: 13, fontWeight: 650, color: TONE_COLOR[tone] ?? TONE_COLOR.muted }}
      >
        {label}
      </Typography>
      {error ? (
        <Typography sx={{ fontSize: 12, color: 'var(--app-text-tertiary)' }}>{error}</Typography>
      ) : null}
    </Stack>
  )
}
